import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';
import { ApiService } from '../shared/services/core/api.service';
import { CampaignManagerOffersModel } from './campaign-v2-offers.model';
import { CampaignV2OffersStore } from './campaign-v2-offers.store';
import { CampaignV2OffersQuery } from './campaign-v2-offers.query';

@Injectable({ providedIn: 'root' })
export class CampaignV2OffersService {
  constructor(
    private api: ApiService,
    private campaignV2OffersStore: CampaignV2OffersStore,
    private campaignV2OffersQuery: CampaignV2OffersQuery
  ) {}

  fetchV2Offers(): Observable<null> {
    const request$: Observable<null> = this.api.getAnySingle<CampaignManagerOffersModel>('purchases/v2/entitlements').pipe(
      tap((response) => {
        this.campaignV2OffersStore.set([response]);
      }),
      mapTo(null)
    );
    return this.campaignV2OffersQuery.getHasCache() ? of(null) : request$;
  }
}
